export default __webpack_public_path__ + "static/media/tete22.251bff48.png";